export const TABS_OPTIONS = [{ label: 'Users', value: 'users' }]
